import {
  ActionIcon, Box,
  Button, Divider,
  Drawer,
  Group, Input, MultiSelect, Popover,
  Select,
  Text,
  Title,
  useCombobox,
  useMantineTheme
} from "@mantine/core";

import { ListViewOption } from "core/components/listToggle/listToggleControl";
import { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CSVGenerator, FilterButton, FormInputWrapper, StatusSelectBox } from "core/components";

import { logger } from "utils/logger";
import {
  IconEye,
  IconReload,
  IconSearch,
  IconTableExport,
  IconX,
} from "@tabler/icons-react";
import { useRef } from "react";

import {
  DateRanges,
  DateSelections,
  filterSamples,
  generateColKeys, getDateRanges, pluralize,
  selectItems
} from "utils/helper";
import { SampleEventType } from "core/models/SampleModel";

import { EmptyState } from "core/components/emptyState/EmptyState";
import { openModal } from "@mantine/modals";

import { useForm } from "@mantine/form";
import CustomDatePicker from "core/components/datePicker/CustomDatePicker";
import moment from "moment";
import {
  selectStyles,
  setProductionWipFilter,
  selectStyle,
  fetchSchedule,
  getScheduleSuccess,
  fetchApprovalSelects,
  getApprovalSelectsSuccess,
} from "modules/Approval/approvalSlice";

import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import InfoPanel from "./InfoPanel";
import { WipFilterModel } from "core/models/WipFilterModel";
import {
  AppConstants, getCompanyTableColumns
} from "utils/constants";
import ProductionList from "./ProductionList";

var _ = require("lodash");

const Production = ({
  stylesResult,
  selectedStyles,
  success,
  error,
  setProductionWipFilter,
  productionWipFilter,
  selectStyles,
  selectStyle,
  selectedStyle,
  user,
}) => {
  const dispatch = useDispatch();
  const [filterOpen, setFilterOpen] = useState(false);
  const [listView, setListView] = useState(ListViewOption.LIST);
  const navigate = useNavigate();
  const location = useLocation();
  // const [selectedItems, setSelectedItems] = useState(selectedStyles);
  const [filterCount, setFilterCount] = useState(0);
  const [wipData, setWipData] = useState(stylesResult.data);
  const [filterItems, setFilterItems] = useState(productionWipFilter);
  const hasInit = useRef(false);

  const [isLoading, setIsLoading] = useState(!stylesResult.data.length);
  const [dateFilterOpen, setDateFilterOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [doFetch, setDoFetch] = useState(true);

  const [fetchStatus, setFetchStatus] = useState(null);
  const [opened, { open, close }] = useDisclosure(false);

  const wips = stylesResult.data;
  const theme = useMantineTheme();
  const tabletMatch = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const selectAllMenu = (
    <div>
      <Button
        variant="default"
        onClick={(e) => onMenuItemClick(SampleEventType.SAMPLE_DISTRIBUTE)}
      >
        Distribute
      </Button>
      <Button variant="default" onClick={(e) => onSelectAll(e)}>
        Deselect All
      </Button>
    </div>
  );
  const columns = user?.clientCode?getCompanyTableColumns(user.clientCode, "productionStyles"):[];

  const filterWips = useCallback(() => {
    var data = filterSamples(wips, productionWipFilter);

    setWipData(data);
  }, [
    productionWipFilter.brands,
    productionWipFilter.categories,
    setWipData,
    wips,
    productionWipFilter.groupBy,
    productionWipFilter.keyword,
  ]);

  /**
   * Effect to handle location change
   */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let displayType = params.get("displayType");

    // set the fetch status so we know what to pass to the criteria
    const status = params.get("status");
    const weekstart = params.get("weekstart");
    const styleNumber = params.get("styleNumber");

    // open the drawer if we have the style
    if (styleNumber && stylesResult) {
      const style = stylesResult.data.find((val) => val.styleNumber === styleNumber);
      if(style){
        dispatch(selectStyle(style));
        dispatch(selectStyles([style]));
        open();
      }
      // dispatch(selectStyle({ id: styleNumber, styleNumber }));
      // dispatch(selectStyles([{ id: styleNumber, styleNumber }]));
      // open();
    }

    if (fetchStatus !== status) {
      setFetchStatus(status);
    }

    if (weekstart) {
      // add seven days onto the date.
      var startDate = new Date(weekstart);
      startDate.setHours(0, 0, 0, 0);

      var endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 7);
      endDate.setHours(23, 59, 59, 999);

      // if it's past the current date set it today
      const today = getDateRanges({ value: DateRanges.TODAY });
      if (endDate > today.endDate) {
        endDate = today.endDate;
      }

      if (startDate > today.startDate) {
        startDate = today.startDate;
      }
      var item;

      // check if the date is one of the predefined values
      switch (startDate.toDateString()) {
        case getDateRanges({
          value: DateRanges.TODAY,
        }).startDate.toDateString(): {
          item = DateSelections[0];
          break;
        }
        case getDateRanges({
          value: DateRanges.THIS_WEEK,
        }).startDate.toDateString(): {
          item = DateSelections[1];
          break;
        }
        case getDateRanges({
          value: DateRanges.LAST_WEEK,
        }).startDate.toDateString(): {
          item = DateSelections[2];
          break;
        }
        default: {
          var item = DateSelections[3];
          break;
        }
      }

      const dataFilter = {
        ...productionWipFilter.dataFilter,
        dateRange: {
          item: item,
          value: [startDate, endDate],
        },
      };

      setProductionWipFilter({ ...productionWipFilter, dataFilter: dataFilter });
    }

    logger.log("location change ", location, " DISPLAY: ", displayType, params);
    // if display type changes
    if (displayType && displayType !== listView) setListView(displayType);
  }, [location, listView, stylesResult]);

  /**
   * Handles the list toggle display
   * @param {*} val
   */
  const listToggleHandler = (val) => {
    navigate({ search: `?displayType=${val}` });
  };

  // Create a debounced version of the search function
  const debouncedSearch = useCallback(
    _.debounce((criteria) => {
      const currentTime = Date.now();
      // Check if item exists and is not expired (e.g., 1 hour = 3600000 ms)
      if (
        stylesResult.data &&
        currentTime - stylesResult.timestamp < AppConstants.CACHE_DELAY_LONG
        && stylesResult.type === "approvalSelects"
      ) {
        // return cachedItem.data;
        setIsLoading(false);
      } else {
        setIsLoading(true);
        dispatch(fetchApprovalSelects(criteria));
        // dispatch(fetchSchedule(criteria));
      }
    }, 300),
    []
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("status");
    let weekstart = params.get("weekstart");

    // set it to this week
    if (!weekstart) {
      // check if we have a dateRange stored in the state if so we use that
      const filterDate = productionWipFilter.dataFilter?.dateRange?.value[0] ?? null;
      if (filterDate) {
        weekstart = moment(filterDate).format("YYYY-MM-DD");
      } else {
        const startDate = getDateRanges({
          value: DateRanges.THIS_WEEK,
        }).startDate;
        weekstart = moment(startDate).format("YYYY-MM-DD");
      }
    }

    const criteria = {
      status: status,
      //   weekStart: fetchStatus === FetchStatus.DISTRIBUTED ? weekstart : null,
      weekStart: weekstart,
    };

    if (doFetch) {
      debouncedSearch(criteria);

      // we only fetch when date changes
      setDoFetch(false);
    }
  }, [fetchStatus, productionWipFilter.dataFilter]);

  useEffect(() => {
    logger.log("setting wips, ", wips);
    //setWipData(wips);

    // set the brands/season/category
    var styleNumbers = {};
    var sessions = {};
    var seasons = {};
    var statuses = {};
    var talents = {};
    var issuers = {};
    var depts = {};
    var sizes = {};

    wips?.forEach((item, idx) => {
      styleNumbers[item.ssSort] = item;
      sessions[item.sessionCode] = item;
      seasons[item.seasonCode] = item;
      // statuses[item.status] = item;
      talents[item.talentNames] = item;
      issuers[item.issuer] = item;
      depts[item.dept] = item;
      sizes[item.size] = item;
    });

    setFilterItems({
      styleNumbers,
      sessions,
      seasons,
      // statuses,
      talents,
      depts,
      issuers,
      sizes,
    });

    filterWips();
  }, [wips, filterWips]);

  const onItemClick = (row) => {
    // we need to select the current wip
    // dispatch(selectWip(item));

    // update the route
    // navigate(`/warehouse/wips/${item.wipNumber}`);
    if (row.subRows && row.subRows.length) {
    } else {
      dispatch(selectStyle(row.original));
      // dispatch(selectStyles([row.original]));

      // searchParams.set("sessionId", row.original.ss);
      // let urlParms = Object.fromEntries([...searchParams]);
      // urlParms.styleNumber = row.original.styleNumber;
      // setSearchParams(urlParms);
      const styleNumber = row.original.ssSort;
      const sessionId = row.original.ssPart;
      navigate(`/approval/production/${sessionId}/${styleNumber}`);

      // open();
    }

    logger.log("on item click");
  };

  const onItemSelected = (e, item, selected, rows) => {
    logger.log(item, selectedStyles);

    var items = [...selectedStyles];

    // if the item is a group then push the elements into the group.
    if (item.type && item.type === "group") {
      if (selected) {
        items.push({ id: item.id });
        item.subRows.forEach((row) => {
          var tmpItem = items.find((val) => val.id === row.id);
          if (!tmpItem) items.push({ id: row.id });
        });
      } else {
        _.remove(items, (val) => {
          return val.id === item.id;
        });

        item.subRows.forEach((row) => {
          _.remove(items, (val) => {
            return val.id === row.id;
          });
        });
      }
    } else {
      // var items = [...selectedSeasons];

      // call general helper to select items
      selectItems(
        e,
        item,
        selected,
        rows.map((val) => val.original),
        items
      );
    }
    selectStyles(items);
  };

  const onSelectAll = () => {
    // if there are items selected remove them
    if (selectedStyles.length) {
      //setSelectedItems([])
      dispatch(selectStyles([]));
    } else {
      //setSelectedItems([...elements])
      dispatch(selectStyles([...wipData]));
    }
  };

  const onMenuItemClick = (e) => {
    logger.log(e);
    switch (e) {
      case SampleEventType.SAMPLE_BUILD_OUTFIT: {
        navigate(`/warehouse/outfitter/create`);
        break;
      }
      case SampleEventType.SAMPLE_DISTRIBUTE: {
        openModal({
          title: `New Distribution (${selectedStyles.length})`,
          size: "80%",
          children: (
            <>
              {/* <Distribution selectedItems={selectedStyles.map((val) => wips.find((wip) => wip.id === val.id))} /> */}
            </>
          ),
        });
        break;
      }
      case SampleEventType.SAMPLE_VIEW: {
        onItemClick(e.data);
        break;
      }
      default: {
        break;
      }
    }
  };

  const setFilterVars = (vals) => {
    logger.log(vals);
    setProductionWipFilter(vals);
  };

  useEffect(() => {
    // filter the data.
    filterWips();
  }, [filterWips]);

  const getFilterCount = (val) => {
    var count = 0;
    const dateKeys = ["otbDate", "distribution", "completed"];
    const ignoreKeys = ["groupBy"];
    Object.entries(val).forEach(([key, value]) => {
      if (value && value.length && ignoreKeys.indexOf(key) === -1) {
        ++count;
      }

      if (key === "status") {
        var statusCount = 0;
        Object.entries(value).forEach(([key, value]) => {
          if (value.length) {
            statusCount = 1;
          }
        });

        count += statusCount;
      }

      if (key === "otbDate") {
        if (value.dateStart.toString() || value.dateEnd.toString()) {
          ++count;
        }
      }

      if (key === "completed") {
        if (value.dateStart.toString() || value.dateEnd.toString()) {
          ++count;
        }
      }

      if (key === "distribution") {
        if (value.dateStart.toString() || value.dateEnd.toString()) {
          ++count;
        }
      }

      // if (dateKeys.indexOf(key) > -1) {
      //   if (isDate(value.dateStart) || isDate(value.dateEnd)) {
      //     ++count;
      //   }
      // }
    });

    return count;
  };

  useEffect(() => {
    const count = getFilterCount(productionWipFilter);
    setFilterCount(count);
  }, [productionWipFilter]);

  const onClearClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopPropagation();

    setProductionWipFilter({ ...new WipFilterModel({ groupBy: productionWipFilter.groupBy }) });

    logger.log("CLEAR CLICK", e);
  };

  const filterButtonHandler = (e) => {
    logger.log("BUTTON CLICK", e, e.nativeEvent);
    setFilterOpen((o) => !o);
  };

  const rowMenuItems = [
    {
      handler: (data) => {
        onItemClick(data);
      },
      label: "View Wip",
      icon: <IconEye size={14} />,
    },
  ];

  useEffect(() => {
    if (success) {
      logger.log("SAMPLE SUCCESS = ", success.type);
      switch (success.type) {
        case getApprovalSelectsSuccess.toString(): {
          setIsLoading(false);
          break;
        }
        default: {
          break;
        }
      }
    }
  }, [success]);

  // const dateRange = productionWipFilter.dataFilter.dateRange.value;

  logger.log(productionWipFilter);
  const reloadHandler = () => {
    setIsLoading(true);
    // dispatch(fetchSchedule({}));
    dispatch(fetchApprovalSelects({}));
  };
  
  return (
    <Box style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Group
        className="main-container-header"
        justify="space-between"
        align="center"
      >
        <Title order={3} lh={"lg"}>
          Production Approvals
        </Title>

        <Group>
          <Text size="xs" c={"dimmed"} visibleFrom="sm">
            Last updated {moment(stylesResult?.timestamp).fromNow()}
          </Text>
          <Button
            variant="default"
            onClick={() => reloadHandler()}
            leftSection={
              <IconReload
                size={AppConstants.ICON_SIZE}
                stroke={AppConstants.ICON_STROKE_WIDTH}
              />
            }
          >
            Reload
          </Button>
          <Button
            variant="default"
            size="sm"
            leftSection={
              <IconTableExport
                stroke={AppConstants.ICON_STROKE_WIDTH}
                size={AppConstants.ICON_SIZE}
              />
            }
            sx={{ textAlign: "left" }}
            // onClick={(e) => onMenuItemClick(BulkActions.EXPORT)}
          >
            <CSVGenerator
              data={wipData ?? []}
              columns={generateColKeys(columns)}
              filename="approval-production-export"
              // ignoreKeys={generateIgnoreKeys(columns,wipData)}
            />
          </Button>
        </Group>

        {/* <ListToggleControl
          value={listView}
          onChange={(val) => listToggleHandler(val)}
          types={[
            {
              label: (
                <Center>
                  <IconList size={16} />
                </Center>
              ),
              value: "list",
            },
            {
              label: (
                <Center>
                  <IconCalendar size={16} />
                </Center>
              ),
              value: "calendar",
            },
          ]}
        /> */}
      </Group>

      <Group
        className="container-action-bar"
        style={{ width: "100%" }}
        justify="space-between"
        height={"100%"}
        py="xs"
      >
        <Group>
          {/* <CheckboxDropdown selectedItems={selectedStyles} onCheckboxClick={onSelectAll} selectMenu={selectAllMenu} /> */}
          <Input
            leftSection={<IconSearch size={AppConstants.ICON_SIZE} />}
            style={{ width: "300px" }}
            value={productionWipFilter.keyword}
            onChange={(e) =>
              setProductionWipFilter({
                ...productionWipFilter,
                keyword: e.currentTarget.value,
              })
            }
            placeholder={`Search across ${wips.length} ${pluralize(
              "Record",
              wips.length
            )}`}
            rightSectionPointerEvents="all"
            rightSection={
              <ActionIcon
                variant="transparent"
                onClick={() =>
                  setProductionWipFilter({
                    ...productionWipFilter,
                    keyword: "",
                  })
                }
              >
                {productionWipFilter.keyword.length ? <IconX size={14} /> : null}
              </ActionIcon>
            }
          />
        </Group>
        <Group>
          {/* {listView !== ListViewOption.CALENDAR ? (
            <Group grow={0}>
              <Popover
                shadow="sm"
                opened={dateFilterOpen}
                onClose={() => setDateFilterOpen(false)}
                width={480}
                position="bottom"
                withArrow
                closeOnClickOutside={true}
                onChange={setDateFilterOpen}
              >
                <Popover.Target>
                  <div>
                    <Button
                      variant="light"
                      onClick={() => setDateFilterOpen((o) => !o)}
                      px={"xs"}
                    >
                      <Group>
                        <Badge color="green" variant="light">
                          {productionWipFilter.dataFilter.dateRange.item.label}
                        </Badge>
                        <Text size={"sm"}>
                          <Moment format="D MMM YYYY">{dateRange[0]}</Moment> -{" "}
                          <Moment format="D MMM YYYY">{dateRange[1]}</Moment>
                        </Text>
                        <IconChevronDown size={14} />
                      </Group>
                    </Button>
                  </div>
                </Popover.Target>
                <Popover.Dropdown>
                  <div style={{ display: "flex" }}>
                    <DateFilterPanel
                      showTimePicker={false}
                      filter={productionWipFilter.dataFilter}
                      onCancel={() => setDateFilterOpen(false)}
                      onApply={(vals) => {
                        let urlParms = Object.fromEntries([...searchParams]);
                        // const urlParms = new URLSearchParams(window.location.search);
                        var startDate = vals.dateRange.value[0];
                        startDate.setHours(0, 0, 0, 0);

                        // if it's past the current date set it today
                        const today = getDateRanges({
                          value: DateRanges.TODAY,
                        });
                        if (startDate > today.startDate) {
                          startDate = today.startDate;
                        }

                        const formattedDate =
                          moment(startDate).format("YYYY-MM-DD");

                        // set the settings as part of the url.
                        searchParams.set("weekstart", formattedDate);
                        urlParms.weekstart = formattedDate;
                        setSearchParams(urlParms);

                        setDateFilterOpen(false);
                        setDoFetch(true);
                      }}
                    />
                  </div>
                </Popover.Dropdown>
              </Popover>
            </Group>
          ) : null} */}
          <Popover
            shadow="sm"
            opened={filterOpen}
            onChange={setFilterOpen}
            width={tabletMatch ? "100%" : 610}
            withArrow
            closeOnClickOutside={true}
            position="bottom-end"
            // onClose={() => setFilterOpen(false)}
          >
            <Popover.Target>
              <div>
                <FilterButton
                  onClick={filterButtonHandler}
                  onClear={onClearClick}
                  count={filterCount}
                />
              </div>
            </Popover.Target>
            <Popover.Dropdown>
              <div wip={{ display: "flex" }}>
                <FilterPanel
                  filter={productionWipFilter}
                  onCancel={() => setFilterOpen(false)}
                  onApply={(vals) => {
                    setFilterVars(vals);
                    setFilterOpen(false);
                  }}
                  filterItems={filterItems}
                />
              </div>
            </Popover.Dropdown>
          </Popover>
          {listView !== ListViewOption.CALENDAR ? (
            <Select
              placeholder="Group By"
              w={230}
              clearable
              value={productionWipFilter.groupBy}
              onChange={(val) => setProductionWipFilter({ ...productionWipFilter, groupBy: val })}
              data={[
                { value: "", label: "No Group" },
                { value: "Dept", label: "Group by Department" },
                {
                  value: "Size",
                  label: "Group by Size",
                },
              ]}
            />
          ) : null}
        </Group>
      </Group>

      {/* <ScrollArea wip={{height:500}} > */}
      <Box
        className={
          productionWipFilter.groupBy && productionWipFilter.groupBy.length
            ? "main-container-content show-data-grouped"
            : "main-container-content show-data-grouped-hidden"
        }
        style={{ flex: 1, marginBottom: 33, flex: 1, overflow: "hidden" }}
      >
        {listView === ListViewOption.LIST ? (
          <div className="table-wrapper" style={{ position: "relative" }}>
            <ProductionList
              originalData={stylesResult.data}
              loading={isLoading}
              data={wipData}
              onItemClick={onItemClick}
              onMenuItemClick={onMenuItemClick}
              onItemSelected={onItemSelected}
              selectedItems={selectedStyles}
              filter={productionWipFilter}
              actionMenu={rowMenuItems}
              columns={columns}
              setFilter={setProductionWipFilter}
            />

            {wipData && wipData.length === 0 && !isLoading ? (
              <Box
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  top: 200,
                }}
              >
                <EmptyState />
              </Box>
            ) : null}

            {/* <TestList wipData={wips} /> */}
          </div>
        ) : (
          //     <SampleList
          //         loading={isLoading}
          //         data={wipData}
          //         onItemClick={onItemClick}
          //         onMenuItemClick={onMenuItemClick}
          //         onItemSelected={onItemSelected}
          //         selectedItems={selectedStyles}
          //         filter={productionWipFilter}
          //         actionMenu={rowMenuItems}
          //         columns={[
          //             {
          //                 // Build our expander column
          //                 id: 'expander', // Make sure it has an ID
          //                 Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
          //                     <>
          //                         {/* <span {...getToggleAllRowsExpandedProps()}>
          //   {isAllRowsExpanded ? <IconChevronDown /> : <IconChevronRight />}
          // </span> */}
          //                     </>
          //                 ),
          //                 Cell: ({ row }) =>
          //                     // Use the row.canExpand and row.getToggleRowExpandedProps prop getter
          //                     // to build the toggle for expanding a row
          //                     row.canExpand ? (
          //                         <span
          //                             {...row.getToggleRowExpandedProps({
          //                                 wip: {
          //                                     // We can even use the row.depth property
          //                                     // and paddingLeft to indicate the depth
          //                                     // of the row
          //                                     paddingLeft: `${row.depth * 2}rem`,
          //                                 },
          //                             })}>
          //                             {row.isExpanded ? <IconChevronDown /> : <IconChevronRight />}
          //                         </span>
          //                     ) : null,
          //             },
          //             {
          //                 Header: 'Photo Code',
          //                 accessor: 'photoCode',
          //             },
          //             {
          //                 Header: 'Wip',
          //                 accessor: 'wipNumber',
          //             },
          //             {
          //                 Header: 'Status',
          //                 accessor: 'status',
          //             },
          //             {
          //                 Header: 'Name',
          //                 accessor: 'name',
          //             },
          //             {
          //                 Header: 'Event',
          //                 accessor: 'seasonCode',
          //             },
          //             {
          //                 Header: 'Session',
          //                 accessor: 'sessionCode',
          //             },
          //             {
          //                 Header: 'Department',
          //                 accessor: 'dept',
          //             },
          //             {
          //                 Header: 'OTB Date',
          //                 accessor: 'otbDate',
          //                 sortType: (a, b) => headerDateSort(a, b, 'otbDate'),
          //             },
          //             {
          //                 Header: 'Completed',
          //                 accessor: 'completed',
          //                 sortType: (a, b) => headerDateSort(a, b, 'completed'),
          //             },
          //             {
          //                 Header: 'Dist Date',
          //                 accessor: 'distributionDate',
          //                 sortType: (a, b) => headerDateSort(a, b, 'distributionDate'),
          //             },
          //             {
          //                 Header: 'Issuer',
          //                 accessor: 'issuer',
          //                 width: 200,
          //             },
          //             {
          //                 Header: '',
          //                 accessor: 'action',
          //                 width: 50,
          //             },
          //             //   ],
          //             // },
          //         ]}
          //         setFilter={setWipFilter}
          //     />
          // <WipGrid
          //     data={wipData}
          //     onItemClick={onItemClick}
          //     onItemSelected={onItemSelected}
          //     selectedItems={selectedStyles}
          // />
          <>{/* <WipCalendar styles={wipData} /> */}</>
        )}
      </Box>
      {/* </ScrollArea> */}

      <Drawer
        id="drawer"
        opened={opened}
        closeOnEscape={false}
        trapFocus={true}
        onClose={() => {
          let urlParms = Object.fromEntries([...searchParams]);
          delete urlParms.styleNumber;
          setSearchParams(urlParms);
          close();
        }}
        title="Quick Style View"
        position="right"
      >
        {/* Drawer content */}
        <InfoPanel selectedItem={selectedStyle} opened={opened} doFetch={false} />
      </Drawer>
    </Box>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    productionWipFilter: state.wipReducer.productionWipFilter,
    selectedStyles: state.wipReducer.selectedStyles,
    selectedStyle: state.wipReducer.selectedStyle,
    wip: state.wipReducer.selectedWip,
    stylesResult: state.wipReducer.productionWipList,
    success: state.wipReducer.success,
    displayPrefs: state.wipReducer.displayPrefs,
    error: state.wipReducer.error,
  };
};

const mapDispatchToProps = { setProductionWipFilter, selectStyles, selectStyle };

export default connect(mapStateToProps, mapDispatchToProps)(Production);

const FilterPanel = ({ onCancel, onApply, filter, filterItems }) => {
  logger.log(" FILTER PANEL", filter, filterItems);
  const form = useForm({
    initialValues: {
      ...filter,
      // completed: { ...filter.completed },
      // otbDate: { ...filter.otbDate },
      completed: {
        dateStart: filter.completed?.dateStart?.toString().length
          ? moment(filter.completed?.dateStart).toDate()
          : "",
        dateEnd: filter.completed?.dateEnd?.toString().length
          ? moment(filter.completed?.dateEnd).toDate()
          : "",
      },
      otbDate: {
        dateStart: filter.otbDate?.dateStart?.toString().length
          ? moment(filter.otbDate?.dateStart).toDate()
          : "",
        dateEnd: filter.otbDate?.dateEnd?.toString().length
          ? moment(filter.otbDate?.dateEnd).toDate()
          : "",
      },
      distribution: {
        dateStart: filter.distribution?.dateStart?.toString().length
          ? moment(filter.distribution?.dateStart).toDate()
          : "",
        dateEnd: filter.distribution?.dateEnd?.toString().length
          ? moment(filter.distribution?.dateEnd).toDate()
          : "",
      },
      // distributionDate: { ...filter.distribution },
      // status:{
      //     sampleCount:filter.status.sampleCount.toString(),
      //     photographyCount:filter.status.photographyCount.toString(),
      //     taskCount:filter.status.taskCount.toString(),
      //     taskCompletedCount:filter.status.taskCompletedCount.toString()
      // }
    },
  });

  // useEffect(() => {
  //   if (filter && form) {
  //     form.setValues({ ...filter });
  //   }
  // }, [filter]);

  const getFilterVars = useCallback(
    (key) => {
      var res = [];
      if (filterItems[key])
        Object.keys(filterItems[key]).forEach((val) => res.push(val));
      return res.sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true })
      );
    },
    [filter, filterItems]
  );

  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  return (
    <Box shadow="xs" wip={{ width: "100%" }} className="filter-panel">
      <form onSubmit={form.onSubmit((values) => onApply(values))}>
        {/* <ScrollArea wip={{ overflowX: "hidden" }}> */}
        <Box>
          <FormInputWrapper label="Styles" labelWidth={"120px"}>
            <MultiSelect
              data={getFilterVars("styleNumbers")}
              label=""
              placeholder="Pick all that you like"
              searchable
              comboboxProps={{ withinPortal: false }}
              // nothingFound="Nothing found"
              {...form.getInputProps("styleNumbers")}
            />
          </FormInputWrapper>

          <FormInputWrapper label="Department" labelWidth={"120px"}>
            <MultiSelect
              data={getFilterVars("depts")}
              label=""
              placeholder="Pick all that you like"
              searchable
              comboboxProps={{ withinPortal: false }}
              // nothingFound="Nothing found"
              {...form.getInputProps("departments")}
            />
          </FormInputWrapper>

          {/* <FormInputWrapper label="Size" labelWidth={"120px"}>
            <MultiSelect
              data={getFilterVars("sizes")}
              label=""
              placeholder="Pick all that you like"
              searchable
              comboboxProps={{ withinPortal: false }}
              // nothingFound="Nothing found"
              {...form.getInputProps("sizes")}
            />
          </FormInputWrapper> */}

          {/* <FormInputWrapper
            label="OTB Date"
            id="input-otbDate"
            labelWidth={"120px"}
          >
            <Group wrap={"nowrap"}>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder="From OTB Date"
                {...form.getInputProps("otbDate.dateStart")}
              />
              <Text>to</Text>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder="To OTB Date"
                {...form.getInputProps("otbDate.dateEnd")}
              />
            </Group>
          </FormInputWrapper> */}

          <FormInputWrapper label="Status" labelWidth={"120px"}>
            <StatusSelectBox searchable={false} defaultValue={form.values.statuses} data={statuses} onChange={(val) => {
              form.setFieldValue("statuses", val);
            }} />
            
          </FormInputWrapper>
          {/* <FormInputWrapper
            label="Completed Date"
            id="input-completed"
            labelWidth={"120px"}
          >
            <Group wrap={"nowrap"}>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder="From Completed Date"
                {...form.getInputProps("completed.dateStart")}
              />

              <Text>to</Text>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder="To Completed Date"
                {...form.getInputProps("completed.dateEnd")}
              />
            </Group>
          </FormInputWrapper>

          <FormInputWrapper
            label="Distribution Date"
            id="input-completed"
            labelWidth={"120px"}
          >
            <Group wrap={"nowrap"}>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder="From Distribution Date"
                {...form.getInputProps("distribution.dateStart")}
              />
              <Text>to</Text>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder="To Distribution Date"
                {...form.getInputProps("distribution.dateEnd")}
              />
            </Group>
          </FormInputWrapper> */}
        </Box>
        {/* </ScrollArea> */}
        <Divider />
        <Group justify="space-between" mt="lg">
          <Button
            variant="subtle"
            component="button"
            size="sm"
            onClick={() => onCancel()}
          >
            Cancel
          </Button>
          <Button type="submit" size="sm" variant="filled">
            Apply
          </Button>
        </Group>
      </form>
    </Box>
  );
};

const statuses = ["","review", "complete"];
